import { Link } from "react-router-dom";

const ENTRIES = [
  {
    label: "电影",
    desc: "欧美院线佳作",
    icon: "ri-movie-2-line",
    to: "/category?type=movie",
    accent: true,
  },
  {
    label: "电视剧",
    desc: "口碑剧集全集",
    icon: "ri-tv-2-line",
    to: "/category?type=tv",
    accent: true,
  },
  {
    label: "新上映",
    desc: "按上映时间排序",
    icon: "ri-calendar-check-line",
    to: "/category?sort=year",
    accent: false,
  },
  {
    label: "经典推荐",
    desc: "值得反复回味",
    icon: "ri-bookmark-3-line",
    to: "/category?topic=classic-series",
    accent: false,
  },
  {
    label: "热门榜单",
    desc: "热度排行前列",
    icon: "ri-fire-line",
    to: "/category?sort=popularity",
    accent: false,
  },
];

export default function QuickEntries() {
  return (
    <section className="mx-auto w-full max-w-[1400px] px-4 pt-10 md:px-8 md:pt-14">
      <div className="mb-5 md:mb-6">
        <h1 className="font-heading text-xl font-bold text-foreground-50 md:text-2xl">
          欧美精品在线观看
        </h1>
        <p className="mt-2 text-sm text-foreground-400">
          精选欧美电影与电视剧，新片与经典一站看全
        </p>
      </div>
      <div className="grid grid-cols-2 gap-3 md:grid-cols-5 md:gap-4">
        {ENTRIES.map((entry) => (
          <Link
            key={entry.label}
            to={entry.to}
            className={`group flex items-center gap-3 rounded-lg border p-3.5 transition-colors md:p-4 cursor-pointer ${
              entry.accent
                ? "border-primary-500/40 bg-primary-500/10 hover:bg-primary-500/20"
                : "border-background-800 bg-background-900 hover:border-accent-500/60"
            }`}
          >
            <span
              className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-md md:h-11 md:w-11 ${
                entry.accent ? "bg-primary-500" : "bg-background-800"
              }`}
            >
              <i
                className={`${entry.icon} text-xl ${
                  entry.accent ? "text-foreground-50" : "text-accent-400"
                }`}
              />
            </span>
            <span className="min-w-0">
              <span className="block text-sm font-medium text-foreground-100 whitespace-nowrap">
                {entry.label}
              </span>
              <span className="block truncate text-[11px] text-foreground-400">{entry.desc}</span>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}